//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { getFileUrl } from '@/utils/common'
import couponListModal from './couponListModal'
import memberLevelModal from './memberLevelModal'
export default {
  name: 'VipInfoPage',
  extends: vComponent,
  components: { couponListModal, memberLevelModal },
  props: {
    info: {
      type: Object,
      default: () => { return null }
    }
  },
  data () {
    return {
      isShowCode: false, // 控制顯示qrcode
      currentModal: { // 正在開啟update的欄位
        title: '',
        fieldName: '',
        val: ''
      },
      isShowAmtModal: false, // 是否顯示點數異動modal,
      inputValue: '',
      isShowCouponModal: false // 控制顯示贈點設定畫面
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'stock_no',
      'theme',
      'storeInfo'
    ]),
    // 消費給點
    useOrderPoint () {
      return this.storeInfo && this.storeInfo.menu && this.storeInfo.menu.USE_ORDER_POINT === 'Y'
    },
    // 發送兌換卷
    useGiveCoupon () {
      return this.storeInfo && this.storeInfo.menu && this.storeInfo.menu.USE_GIVE_COUPON === 'Y'
    },
    // 會員升級
    useLevelUpgrade () {
      return this.storeInfo && this.storeInfo.menu && this.storeInfo.menu.USE_LEVEL_UPGRADE === 'Y'
    }
  },
  async created () {
  },
  mounted () {
    console.log('storeInfo==')
    console.log(this.storeInfo)
  },
  watch: {
  },
  methods: {
    getFileUrl,
    moment,
    alert (message) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        this.isShowAmtModal = false
      })
    },
    clickPosBtn () {
      console.log(`cordova==`)
      console.log(window.cordova)
      if (window.cordova !== undefined) {
        const appPackageName = 'com.bethel.v1'
        this.openApp(appPackageName, (result, data) => {
          if (result !== 'OK') this.alert(data)
        })
      } else {
        this.alert(`網頁版本不支援開啟POS`)
      }
    },
    // need plugin com.lampa.startapp
    checkAppExist (_appPackageName, callback = null) {
      if (window.startApp !== undefined) {
        window.startApp.set({ package: _appPackageName }).check(() => {
          // eslint-disable-next-line standard/no-callback-literal
          if (callback !== null) callback('OK', `app[${_appPackageName}] Available`)
          this.alert(`app[${_appPackageName}] Available`)
        }, () => {
          // eslint-disable-next-line standard/no-callback-literal
          if (callback !== null) callback('ERROR', `app[${_appPackageName}] not Available`)
          this.trace(`app[${_appPackageName}] not Available`)
        })
      } else {
        this.alert('[Warning]startApp not exist')
      }
    },
    openApp (_appPackageName, callback = null) {
      // _appName = com.application.name
      this.checkAppExist(_appPackageName, (result, info) => {
        if (result === 'OK') {
          window.startApp.set({ application: _appPackageName }).start(() => {
            // success
            // eslint-disable-next-line standard/no-callback-literal
            if (callback !== null) callback('OK', `open app[${_appPackageName}] success`)
          }, (error) => {
            // /* error */
            // eslint-disable-next-line standard/no-callback-literal
            if (callback !== null) callback('ERROR', `open app[${_appPackageName}] error=${error}`)
          })
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          if (callback !== null) callback('ERROR', info)
        }
      })
    },
    // 金額異動
    async clickAmtUpdate () {
      const data = {
        SITE: this.site,
        REALTIME: true,
        QUEUE: [{
          ID_NO: this.params.id_no,
          STOCK_NO: this.stock_no,
          TRN_DATE: moment().format('YYYYMMDD'),
          TRANS_ID: `crm_${new Date().getTime()}`,
          TOTAL: parseInt(this.inputValue),
          LOGDATA: [{
            PLU_CODE: '001',
            PC_NAME: '一般商品',
            QTY: 1,
            AMT: parseInt(this.inputValue)
          }]
        }]
      }
      console.log(data)
      const response = await this.fetch('transImport', data)
      if (response.result === 'OK') {
        this.alert(`消費給點數成功`)
        this.emit('ReloadPage')
      } else {
        this.alert(`消費給點數失敗`)
      }
    }
  }
}
